module.exports = __webpack_public_path__ + "static/media/aqua_04.6647ae5b.JPG";